export const NAV_LIST = [
    {
        label: "Offboarding",
        href: "/Offboarding",
    },
];

export const DEBOUNCE_DELAY = 700;

export function generate_tabs_offboarding(data = null) {
    const tabs = {
        waiting_offboarding: {
            id: 0,
            label: "À préparer",

            description: data?.waiting_offboarding_users?.length ?? 0,
            backend_string: "waiting_offboarding",
        },
        Offboarding: {
            id: 1,
            label: "Offboarding",
            description: null,
            backend_string: "offboarding",
        },
        Archived: {
            id: 2,
            label: "Archivé",
            // description: data?.archived_users?.length ?? 0,
            description: null,
            backend_string: "archived",
        },
    };
    const json = {
        tabs,
        tabs_array: Object.values(tabs),
    };
    return json;
}

export const _dynamic_tab_head = {
    key: "header_table",
    style: { color: "red" },
    items: [
        {
            key: "header1",
            content: "Collaborateur",
            style: {
                textAlign: "start",
                width: "200px",
            },
        },
        {
            key: "header2",
            content: "Département",
            style: {
                width: "210px",
                textAlign: "end",
            },
        },
        {
            key: "header3",
            content: "Début du contrat",
            style: {
                textAlign: "center",
                width: "260px",
            },
        },
        {
            key: "header4",
            content: "Fin période d'essai",
            style: {
                textAlign: "start",
                width: "240px",
            },
        },
        {
            key: "header5",
            content: "Statut",
            style: {
                textAlign: "start",
                width: "200px",
            },
        },
        {
            key: "header6",
            content: "Tâches restantes",
            style: {
                textAlign: "end",
                width: "200px",
            },
        },
    ],
};
